import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Knives for friends',
    subtitle: 'Top 5 take knives, 6–20 take coins',
    prizeAlt: 'Contest knife',
    myPlace: 'Your place',
  },
  ru: {
    title: 'Ножи за друзей',
    subtitle: 'Топ-5 — ножи, 6–20 — монеты',
    prizeAlt: 'Нож конкурса',
    myPlace: 'Твоё место',
  },
  uz: {
    title: 'Doʻstlar uchun pichoq',
    subtitle: 'Top-5 — pichoq, 6–20 — tanga',
    prizeAlt: 'Tanlov pichogʻi',
    myPlace: 'Sening oʻrning',
  },
  fa: {
    title: 'چاقو برای دوستان',
    subtitle: 'پنج نفر اول چاقو می‌برند، نفرات 6 تا 20 سکه',
    prizeAlt: 'چاقوی مسابقه',
    myPlace: 'جایگاه تو',
  },
  pt: {
    title: 'Facas por amigos',
    subtitle: 'Top 5 — facas, 6–20 — moedas',
    prizeAlt: 'Faca do concurso',
    myPlace: 'Sua posição',
  },
  tr: {
    title: 'Arkadaş getir, bıçak kazan',
    subtitle: 'İlk 5 — bıçak, 6–20 — coin',
    prizeAlt: 'Yarışma bıçağı',
    myPlace: 'Sıran',
  },
  uk: {
    title: 'Ножі за друзів',
    subtitle: 'Топ-5 — ножі, 6–20 — монети',
    prizeAlt: 'Ніж конкурсу',
    myPlace: 'Твоє місце',
  },
  de: {
    title: 'Messer für Freunde',
    subtitle: 'Top 5 gewinnen Messer, Platz 6–20 Münzen',
    prizeAlt: 'Messer des Wettbewerbs',
    myPlace: 'Dein Platz',
  },
  es: {
    title: 'Cuchillos por amigos',
    subtitle: 'Top 5: cuchillos; del 6 al 20: monedas',
    prizeAlt: 'Cuchillo del concurso',
    myPlace: 'Tu puesto',
  },
  pl: {
    title: 'Noże za znajomych',
    subtitle: 'Top 5 — noże, 6–20 — monety',
    prizeAlt: 'Nóż konkursu',
    myPlace: 'Twoje miejsce',
  },
});
